import React, { Component } from 'react';

class ProductDetails extends Component {
  render() {
    return <></>
  }
}

export default ProductDetails;
